
import { 
  Shield, 
  Clock, 
  HeartHandshake, 
  Wallet, 
  Users, 
  Smartphone
} from "lucide-react";

const features = [
  {
    icon: <Shield className="h-6 w-6" />,
    title: "Coberturas Completas",
    description: "Protección integral para todos los aspectos de tu vida con planes personalizados."
  },
  {
    icon: <Clock className="h-6 w-6" />,
    title: "Servicio 24/7",
    description: "Asistencia constante cuando más lo necesitas, sin importar la hora o el día."
  },
  {
    icon: <HeartHandshake className="h-6 w-6" />,
    title: "Asesoría Personalizada",
    description: "Expertos dedicados a encontrar la solución que mejor se adapte a tus necesidades específicas."
  },
  {
    icon: <Wallet className="h-6 w-6" />,
    title: "Precios Competitivos",
    description: "Las mejores coberturas con tarifas ajustadas a tu presupuesto y necesidades reales."
  },
  {
    icon: <Users className="h-6 w-6" />,
    title: "Equipo Profesional",
    description: "Agentes licenciados con años de experiencia en el mercado de seguros."
  },
  {
    icon: <Smartphone className="h-6 w-6" />,
    title: "Gestión Digital",
    description: "Maneja tus pólizas desde cualquier dispositivo con nuestra plataforma intuitiva."
  }
];

const Features = () => {
  return (
    <section id="features" className="py-24 px-6 bg-gradient-to-b from-background to-secondary/10 relative">
      <div className="absolute top-0 left-0 right-0 h-16 bg-background transform skew-y-2 origin-left -translate-y-8"></div>
      
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="px-3 py-1 rounded-full bg-white/90 text-sm font-medium mb-4 inline-block shadow-sm">
            NUESTROS SERVICIOS
          </span>
          <h2 className="text-3xl md:text-4xl font-display font-medium mb-4 text-[#0c4a6e]">
            Soluciones de Seguros a tu Medida
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto text-[#075985]">
            Ofrecemos una amplia gama de productos diseñados para proteger lo que más te importa.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-8 shadow-md hover:shadow-lg transition-all duration-300 border border-[#e0f2fe]/50 group"
            >
              <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-[#0EA5E9]/80 to-[#0284c7] flex items-center justify-center mb-6 shadow-md group-hover:shadow-lg transition-all">
                <div className="text-white">{feature.icon}</div>
              </div>
              <h3 className="text-xl font-medium mb-3 text-[#0c4a6e]">{feature.title}</h3>
              <p className="text-[#64748b]">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
